import { render, staticRenderFns } from "./NotarialDetails.vue?vue&type=template&id=6a3d1958&scoped=true"
import script from "./NotarialDetails.vue?vue&type=script&scoped=true&lang=js"
export * from "./NotarialDetails.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./NotarialDetails.vue?vue&type=style&index=0&id=6a3d1958&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3d1958",
  null
  
)

export default component.exports